<template>
    <div class="vote">
        <el-table :data="userlist" border v-loading="loading" :height="height" class="tableLimit votebox">
            <el-table-column prop="real_name" label="用户名"></el-table-column>
            <el-table-column prop="nickname" label="头像">
                <template slot-scope="scope">
                    <div class="block">
                        <el-avatar :size="50" :src="scope.row.head_portrait_pic[0].url"></el-avatar>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="create_time" label="时间" show-overflow-tooltip></el-table-column>
            <el-table-column label="查看记录" align="center">
                <template slot-scope="scope">
                    <el-link type="primary" @click="openuserSurlist(scope.row)">查看</el-link>
                </template>
            </el-table-column>
        </el-table>
        <div class="u-f u-ac u-jsb ft_mr">
            <div></div>
            <div>
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="currentPage" :page-sizes="[10, 30, 50, 100]" :page-size="pagesize"
                    layout="total, sizes, prev, pager, next, jumper" :total="count">
                </el-pagination>
            </div>
        </div>

        <el-dialog title="记录" :visible.sync="userSurlist" top="20px" width="30%" class="dialogs" append-to-body>
            <el-divider></el-divider>
            <div class="outbox">
                <div class="sur_top_img">
                    <img v-if="userallSur.file_info" :src="userallSur.file_info[0].url" alt="">
                </div>
                <div class="contents_b">
                    <div class="tit">
                        {{userallSur.questionnaire_name}}
                    </div>
                    <p class="tit_con">
                        {{userallSur.detail}}
                    </p>
                    <div v-for="(ops,index) in userallSurPro" :key="index">
                        <div class="items" v-if="ops.choose_type==1">
                            <div class="s_tit"><span style='color:red'>*</span>{{ops.problem}} </div>
                            <div v-for="(o,ind) in ops.options" :key="ind">
                                <div> {{o.option}}</div>
                                <el-progress :percentage="o.choice_lv" :color="o.selected==1?'#409EFF':'#999'">
                                </el-progress>
                            </div>
                        </div>
                        <div class="items" v-if="ops.choose_type==2">
                            <div class="s_tit"><span style='color:red'>*</span>{{ops.problem}}</div>
                            <div v-for="(o,ind) in ops.options" :key="ind">
                                <div> {{o.option}}</div>
                                <el-progress :width="50" :percentage="o.choice_lv" :color="o.selected==1?'#409EFF':'#999'">
                                </el-progress>
                            </div>
                            <div  v-if="ops.option_type&&ops.option_type==2&&ops.option_value" class="op_value">
                                {{ops.option_value}}
                            </div>
                        </div>
                       <div class="items" v-if="ops.choose_type==3">
                            <div class="s_tit"><span style='color:red'>*</span>{{ops.problem}}</div>
                             <div class="op_value">
                                {{ops.option_value}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="userSurlist=false" size="small">确定</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                userlist: [],
                eid: '',
                loading: false,
                height: null,
                pagesize: 10,
                currentPage: 1,
                count: 0,
                userSurlist: false,

                userallSur: '',
                userallSurPro: '',
            }
        },
        mounted() {
            this.getHeight()

        },
        methods: {
            getHeight() {
                let that = this

                that.height = window.innerHeight - 175 + 'px'
                window.onresize = () => {

                    that.height = window.innerHeight - 175 + 'px'
                }
            },
            getuserlist(id) {
                this.loading = true
                axios
                    .post("/admin/pc/questionnaire/questionnaireUsers", {
                        id: id,
                        page: this.currentPage,
                        page_count: this.pagesize,
                    }, {
                        token: true
                    })
                    .then(response => {
                        if (response.data.code == '200') {
                            this.loading = false
                            this.userlist = response.data.data.list
                            this.count = response.data.data.total

                        } else {
                            that.$message.error(response.data.msg);
                        }
                    })
                    .catch(error => {})
            },
            handleCurrentChange(val) {
                this.currentPage = val
                this.getuserlist(this.eid)
            },
            handleSizeChange(val) {
                this.pagesize = val
                this.currentPage = 1
                this.getuserlist(this.eid)
            },
            async openuserSurlist(row) {
                this.userSurlist = true
                let res = await this.ajax('questionnaire/read', {
                    id: this.eid,
                    user_id: row.create_user
                })
                this.userallSur = res.data
                this.userallSurPro = res.data.problems
            }
        }
    }
</script>

<style lang="scss" scoped>
    .sur_top_img {
        width: 100%;

        img {
            width: 100%;
        }
    }
    .outbox{
        max-height: 720px;
        overflow: auto;
    }

    .contents_b {
        padding: 15px;

        .tit {
            padding: 10px 0;
            font-size: 19px;
            font-weight: 600;
            text-align: center;
        }

        .tit_con {
            color: #666666;
            margin-bottom: 15px;
            font-size: 14px;
        }

        .items {
            padding: 10px 0;

            .s_tit {
                padding: 5px 0;
                font-size: 17px;
                font-weight: 600;
            }

            .op_it_s {
                margin-bottom: 4px;
            }

            .ops_b {
                padding: 0 10px;
            }
            .op_value{
                margin-top: 5px;
                border: 1px solid  rgb(187, 187, 187);
                border-radius: 3px;
                padding: 3px;
            }
        }
    }
  /deep/  .el-progress-bar{
        width: 96%;
    }
</style>